module.exports = "\n.order-left-section{width:24%; float:left; border-right:1px solid #abbbc4;}\n.order-right-section{width:76%; float:left; background:#f5f5f5;}\n@media screen and (max-width: 1024px) {\n\t.order-left-section{width:32%;}\n.order-right-section{width:68%;}\n}\n@media screen and (max-width: 768px) {\n.order-left-section{width:38%;}\n.order-right-section{width:62%;}\n}\n@media screen and (max-width: 640px) {\n.order-left-section{width:100%;}\n.order-right-section{width:100%;}\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/orders/orders.component.css
// module id = ./src/app/orders/orders.component.css
// module chunks = main